import {
  CalendarRequestType,
  CalendarRequestUiConfig
} from 'src/app/models/calendar-request-type';

export const CALENDAR_REQUEST_UI: Record<
  CalendarRequestType,
  CalendarRequestUiConfig
> = {
  Malattia: {
    icon: 'assets/images/icon_calendar/sickness_s.svg',
    cssClass: 'req-sickness',
    tooltip: 'Malattia'
  },
  Permesso: {
    icon: 'assets/images/icon_calendar/permission_s.svg',
    cssClass: 'req-permission',
    tooltip: 'Permesso'
  },
  Ferie: {
    icon: 'assets/images/icon_calendar/vacation_s.svg',
    cssClass: 'req-vacation',
    tooltip: 'Ferie'
  },
  Review: {
    icon: 'assets/images/icon_calendar/review_s.svg',
    cssClass: 'req-review',
    tooltip: 'Review'
  },
  'Smart intera giornata': {
    icon: 'assets/images/icon_calendar/smart_s.svg',
    cssClass: 'req-smart',
    tooltip: 'Smart (giornata)'
  },
  'Smart mattina': {
    icon: 'assets/images/icon_calendar/morning_smart_s.svg',
    cssClass: 'req-smart-morning',
    tooltip: 'Smart (mattina)'
  },
  'Smart pomeriggio': {
    icon: 'assets/images/icon_calendar/afternoon_smart_s.svg',
    cssClass: 'req-smart-afternoon',
    tooltip: 'Smart (pomeriggio)'
  },
  'Sprint review': {
    icon: 'assets/images/icon_calendar/sprint_review_s.svg',
    cssClass: 'req-sprint-review',
    tooltip: 'Sprint review'
  },
  Corso: {
    icon: 'assets/images/icon_calendar/course_s.svg',
    cssClass: 'req-course',
    tooltip: 'Corso'
  }
};

export const DEFAULT_REQUEST_UI: CalendarRequestUiConfig = {
  icon: 'assets/images/icon_calendar/default.svg', // oppure ''
  cssClass: 'req-default',
  tooltip: 'Richiesta'
};
